var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBestbuyProductsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6ebe0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.20259,
    stopColor: "#f6eb8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#f6eb16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6b116"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.52057,48.17163c.36646.21155.81787.21155,1.18433,0l16.11841-9.30554c.78955-.45587.78961-1.59552,0-2.05139l-5.6098-3.23883-18.48682,10.67346,6.79388,3.9223Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.40259,38.86615l5.1319,2.96283,18.48706-10.67334-6.31635-3.64673c-.36646-.21161-.81793-.21161-1.18439,0l-16.11823,9.30585c-.78955.45587-.78955,1.59552,0,2.05139Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.10565,63.14972l16.18451,9.34412c.76733.44305,1.7265-.11072,1.7265-.99677v-18.68817c0-.41125-.21936-.7912-.5755-.99683l-6.8717-3.96753v9.87964l-4.19214-2.17682v-10.12317l-5.12061-2.95642c-.76733-.44305-1.72656.11072-1.72656.99683v18.68835c0,.41119.21942.7912.5755.99677Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.7041,54.85376l-.59882,6.0755,4.2934,4.98297,19.1637,1.83405,1.41388-15.05902-19.09851-1.83411-5.17365,4.00061ZM52.92719,58.94086c-.43518-.04114-.75415-.42926-.71301-.86438.0426-.43518.42932-.75415.86444-.71301.43518.04114.75415.42786.71295.86444-.04102.43512-.42767.75421-.86438.71295Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBestbuyProductsScraper);
export default __webpack_public_path__ + "static/media/bestbuy-products-scraper.b6e44e8b4b38b1344a026ab92b40b78d.svg";
export { ForwardRef as ReactComponent };